import { Button as AntButton, Modal } from "antd";
import { FC, useEffect } from "react";
import { getParent, getStudent } from "../../../api/students.api";
import useAxios from "../../../hooks/useAxios";
import { addHyphen } from "../../../lib/util";
import { IGetParent, IGetStudent } from "../../../models/students.model";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import { useTranslation } from "react-i18next";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  passengerInfo: any;
}

const ShowStudentModal: FC<IProps> = ({
  visible,
  setVisible,
  passengerInfo,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetStudent>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetParent>();

  useEffect(() => {
    if (passengerInfo?.passengerMemCode && passengerInfo?.passengerCampusCode) {
      const memberCode = passengerInfo.passengerMemCode;
      const campusCode = passengerInfo.passengerCampusCode;
      execute(getStudent(memberCode, campusCode));
      execute2(getParent(memberCode));
    }
  }, [passengerInfo]);

  const getStudentImage = () => {
    if (!res?.data) return null;

    if (res.data.profileImg?.thumbnailLocation) {
      return res.data.profileImg?.thumbnailLocation;
    } else {
      return res.data.profileImg?.fileLocation;
    }
  };

  return (
    <>
      {isLoading || isLoading2 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <Modal
        title={passengerInfo?.passengerKorName}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={320}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('shuttle.text.20')}
            </AntButton>
          </div>
        ]}
      >
        <div className="text-center">
          {
            getStudentImage()
              ? (
                <img
                  className="img-preview"
                  src={getStudentImage() || undefined}
                  alt="student"
                  style={{ maxWidth: '100%' }}
                />
                )
              : t('shuttle.text.21')
          }
        </div>
        <hr />
        <div className="text-center">
          {t('shuttle.text.22')} <a href={`tel:${res2?.data?.mobilePhone}`}>{addHyphen(res2?.data?.mobilePhone)}</a>
        </div>
      </Modal>
    </>
  );
}

export default ShowStudentModal;
